// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2AwhA","error":"Textarea_error__35RAO","readonly":"Textarea_readonly__1gUzi","disabled":"Textarea_disabled__3GhKc"};